export default event => event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift');